import React from 'react';
import Slider from 'react-slick';
import '../../../styles/slick/slick-theme.css';
import '../../../styles/slick/slick.css';
import css from './Sections.module.css';
import img1 from '../../../assets/product-1.png';
import img2 from '../../../assets/product-2.png';
import img3 from '../../../assets/product-3.png';
import img4 from '../../../assets/product-4.png';
import { NamedLink } from '../../../components';

function SectionShopProduct({ intl, useHistoryPush }) {
  const categoryItems = [
    {
      labelId: 'SectionShopByCategory.category.buildingMaterials',
      slug: 'cat-stone-tile',
      image: img1,
      link: 'Shop now',
    },
    {
      labelId: 'SectionShopByCategory.category.lighting',
      slug: 'cat-lighting',
      image: img2,
      link: 'Shop now',
    },
    {
      labelId: 'SectionShopByCategory.category.furniture',
      slug: 'cat-furniture',
      image: img3,
      link: 'Shop now',
    },
    {
      labelId: 'SectionShopByCategory.category.textiles',
      slug: 'cat-textiles',
      image: img4,
      link: 'Shop now',
    },
  ];
  const SliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: false,
    focusOnSelect: false,
    centerMode: false,
    responsive: [
      { breakpoint: 1500, settings: { slidesToShow: 4 } },
      { breakpoint: 1300, settings: { slidesToShow: 4 } },
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <div className={css.categoryContainer}>
      <div className={css.sectionHead}>
        <h2>{intl.formatMessage({ id: 'SectionShopByProduct.heading' })}</h2>
      </div>
      <div className={css.sectionContent}>
        <div className={css.productSlider}>
          <Slider {...SliderSettings}>
            {categoryItems.map(({ labelId, slug, image, link }, index) => (
              <div
                key={index}
                className={css.categoryItem}
                onClick={() => useHistoryPush('SearchPage', {}, { pub_categoryLevel1: slug })}
              >
                <div className={css.categoryImg}>
                  <img src={image} alt="" />
                </div>
                <div className={css.shopNowSec}>
                  <NamedLink name="SearchPage" params={{}} query={{ pub_categoryLevel1: slug }}>
                    {link}
                  </NamedLink>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default SectionShopProduct;
